import { useEffect, useState } from 'react';
import cx from 'classnames';
import styles from './Tabs.module.scss';

interface Props {
  children: any[];
  initialTab: any;
  secondary?: boolean;
}
const Tabs: React.FC<Props> = ({ children, initialTab, secondary }) => {
  const [activeTab, setActiveTab] = useState(initialTab);

  const handleClick = (label: string) => {
    setActiveTab(label);
  };

  useEffect(() => {
    if (initialTab.tab) {
      setActiveTab(initialTab.tab);
      console.log(initialTab);
    }
  }, []);

  return (
    <div className={!secondary ? styles.navTabs : styles.secondaryNavTabs}>
      <ul>
        {children.map((tab, idx) => {
          const label = tab.props.label as string;
          return (
            <li key={tab.props.label || `tabs-idx-${idx}`}>
              <button
                onClick={() => handleClick(label)}
                className={
                  activeTab === tab.props.label
                    ? cx(styles.navItem, !secondary ? styles.active : styles.activeSecondary)
                    : styles.navItem
                }
              >
                {label}
              </button>
            </li>
          );
        })}
      </ul>
      {children.map((output) => {
        if (output.props.label === activeTab)
          return (
            <div key={output.props.label} className={styles.outputContainer}>
              {output.props.children}
            </div>
          );
      })}
    </div>
  );
};

export default Tabs;
